import { Component, Prop, h, Element } from '@stencil/core';
import { htmlSanitizer } from '@utils/html-sanitizer';

@Component({
  tag: 'vs-sct',
})
export class SimpleContentTile {
  @Prop() eyebrow: string;
  @Prop() cta: any; // Add cta property to extract link data
  @Prop() desktopImagePath: string;
  @Prop() alt: string;
  @Prop() disableLazyLoading: string;
  @Prop() header: string;
  @Prop() gradientOverlay: string;
  @Prop() uniqueId: string;
  @Prop() layout: string;

  @Element() el: HTMLElement;

  private getAltClass() {
    return this.gradientOverlay === 'vs-bg-black' || this.gradientOverlay === 'vs-bg-primary-dark' || this.gradientOverlay === 'vs-bg-primary'
      ? 'vs-alt'
      : '';
  }

  componentDidLoad() {
    // Find the <a> tag inside the vs-link component
    const vsLink = this.el.querySelector('vs-link');
    const anchorTag = vsLink && vsLink.querySelector('a');

    if (anchorTag) {
      // Clear any existing content inside the <a> tag
      while (anchorTag.firstChild) {
        anchorTag.removeChild(anchorTag.firstChild);
      }

      // Move the content inside the <a> tag
      const contentToMove = this.el.querySelector('.content-to-move');
      if (contentToMove) {
        while (contentToMove.firstChild) {
          anchorTag.appendChild(contentToMove.firstChild);
        }
        contentToMove.remove(); // Remove the outer .content-to-move div
      }

const vsHeadDiv = this.el.querySelector('.vs-ct-head');
if (vsHeadDiv) {
  vsHeadDiv.innerHTML = `${this.eyebrow && '<span class="vs-lead">' + this.eyebrow + '</span>'} ${htmlSanitizer(this.header)}`;
}
if (anchorTag.className) {
  vsHeadDiv.className += ` ${anchorTag.className}`;
}
anchorTag.className = '';

      // Add the data-layout attribute
      anchorTag.setAttribute('data-layout', this.layout);
      
      // Append the classes 'vs-ct' and 'vs-sct' to the <a> tag
      anchorTag.classList.add('vs-ct', 'vs-sct');
    }
  }

  render() {
    return (
      <div style={{ height: '100%' }}>
        {
          this.cta.map(ctaItem => (
            <vs-link
              link-aria-label={ctaItem.ctaLinkAriaLabel}
              button-color={ctaItem?.ctaButtonColor || 'primary'}
              link-conversion={ctaItem?.ctaConversionType}
              link-type={ctaItem?.ctaLinkType}
              link-style={ctaItem?.ctaStyle}
              link-target={ctaItem?.ctaLinkTarget}
              link-text={ctaItem?.ctaTitle}
              class={`${ctaItem?.ctaLinkType === 'internal' && ctaItem?.ctaLinkTarget === 'same' ? 'vs-animation-link' : ''}`}
              img-path={ctaItem?.CtaVideoImagePath}
              video-title={ctaItem?.CtaVideoTitle}
              video-url={ctaItem?.ctaLinkType === 'video' ? ctaItem?.ctaVideoUrl : undefined}
              link-val={ctaItem?.ctaLink}
              modal-target={ctaItem?.ctaUniqueId}
              is-no-follow={ctaItem?.ctaNoFollow ? 'nofollow' : undefined}
            ></vs-link>
          ))
        }
        <div class="content-to-move">
          <div class={`vs-ct-overlay ${this.gradientOverlay || ''}`}>
          <div class={`vs-ct-head  ${this.getAltClass()} `}>
            {}
          </div>
          </div>
          <div class={`${this.gradientOverlay || ''}-gradient`}>
            <img
              src={this.desktopImagePath}
              alt={this.alt || ''}
              class="vs-ct-image vs-img-placeholder"
            />
          </div>
        </div>
      </div>
    );
  }
}
